import { el } from './dom.js';

export interface Modal { dialog: HTMLDialogElement; body: HTMLElement; close: () => void; }

/**
 * Tıklama açılır pencerenin dışına mı düştü? `<dialog>` arka planına yapılan tıklama da hedef olarak
 * dialog'u verdiği için içerideki boşluktan ayırmak üzere kutu sınırlarına bakılır.
 */
function clickedOutside(dialog: HTMLDialogElement, e: MouseEvent): boolean {
  if (e.target !== dialog) return false;
  const r = dialog.getBoundingClientRect();
  if (r.width === 0 && r.height === 0) return false;
  return e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
}

/** Dışarı tıklama ve Esc ile kapanmayı bağlar; `<dialog>` bunu kendiliğinden yapmaz. */
export function closeOnOutsideClick(dialog: HTMLDialogElement, close: () => void): void {
  dialog.addEventListener('click', (e) => { if (clickedOutside(dialog, e)) close(); });
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
}

/** Başlıklı, kapatılabilir açılır pencere. Gövde çağıran tarafından doldurulur. */
export function openModal(opts: { title: string; wide?: boolean; footer?: (Node | string)[]; onClose?: () => void }): Modal {
  const body = el('div', { class: 'modal-body' });
  const foot = el('p', { class: 'modal-foot' });
  const dialog = el('dialog', { class: opts.wide ? 'modal wide' : 'modal' }, [el('h3', {}, [opts.title]), body, foot]) as HTMLDialogElement;
  let closed = false;
  const close = () => {
    if (closed) return;
    closed = true;
    dialog.remove();
    // Arkadaki sayfanın kaydırma kilidi yalnızca son açık pencere kapanınca kalkar.
    if (!document.querySelector('dialog.modal')) document.documentElement.classList.remove('modal-open');
    opts.onClose?.();
  };
  if (opts.footer) {
    foot.append(...opts.footer);
  } else {
    const closeBtn = el('button', { type: 'button', class: 'secondary' }, ['Kapat']);
    closeBtn.addEventListener('click', close);
    foot.append(closeBtn);
  }
  closeOnOutsideClick(dialog, close);
  document.body.append(dialog);
  // Tarayıcılar <dialog> açıkken arka planı kilitlemez; fare tekerleği alttaki sayfayı kaydırmasın.
  document.documentElement.classList.add('modal-open');
  if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
  return { dialog, body, close };
}
